import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Component, Inject, OnInit } from '@angular/core';
import { ApplicationFacade } from '@ridango/components';
import Env from '@ridango/core/env';
import { ThemeFeature } from '@ridango/core/lib/enums/features.enum';
import { Observable } from 'rxjs';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';

@Component({
    selector: 'gl-splash-screen',
    templateUrl: './splash-screen.component.html',
    styleUrls: ['./splash-screen.component.scss']
})
export class SplashScreenComponent implements OnInit {
    logoSplash$: Observable<SafeHtml>;
    logoSplashDefaultImg = 'splashScreenLogo.svg';
    logoSplashBackgroundClass: string;

    constructor(
        @Inject('ENV') public env: Env,
        private applicationFacade: ApplicationFacade,
        private http: HttpClient,
        private sanitizer: DomSanitizer
    ) {}

    ngOnInit(): void {
        this.setBackground();
        this.applicationFacade.setAssetsPath(this.env.ASSETS_DIR);
        this.applicationFacade.updateTermsUrl();

        this.logoSplash$ = this.applicationFacade.highContrast$.pipe(
            withLatestFrom(this.applicationFacade.assetsPath$),
            switchMap(([highContrast, assetsPath]) => {
                const logoPath =
                    this.env.APP_NAME !== 'sormland' && highContrast
                        ? `${assetsPath}/img/splashScreenLogoContrast.svg`
                        : `${assetsPath}/img/${this.logoSplashDefaultImg}`;

                return this.http.get(logoPath, { responseType: 'text' }).pipe(
                    map((svgContent) => this.sanitizer.bypassSecurityTrustHtml(svgContent)),
                    catchError(() => this.setDefaultLogo())
                );
            })
        );
    }

    setBackground() {
        switch (this.env.THEME_NAME) {
            case ThemeFeature.SORMLAND_V2:
                this.logoSplashBackgroundClass = 'bg-white';
                break;
            case ThemeFeature.GOTLAND_V2:
                this.logoSplashBackgroundClass = 'bg-secondary';
                break;
            case ThemeFeature.OREBRO:
                this.logoSplashBackgroundClass = 'bg-secondary';
                break;
            case ThemeFeature.VARMLAND:
                this.logoSplashBackgroundClass = 'bg-secondary';
                break;
            case ThemeFeature.PEUTK:
                this.logoSplashBackgroundClass = 'bg-grey-light';
                break;
            default:
                this.logoSplashBackgroundClass = 'bg-primary';
        }
    }

    setDefaultLogo(): Observable<SafeHtml> {
        const defaultPath = `${this.env.ASSETS_DIR}/img/${this.logoSplashDefaultImg}`;
        return this.http
            .get(defaultPath, { responseType: 'text' })
            .pipe(map((svgContent) => this.sanitizer.bypassSecurityTrustHtml(svgContent)));
    }
}
